import React from "react";
import {css} from "@panda/css";

import {Text} from "@pg-design/text-module";
import {numberFormat, pluralize} from "@pg-mono/string-utils";

import {SeoMainHeadline} from "../../../atoms/SeoMainHeadline";
import {IVendorRegion} from "../../actions/fetch_vendor_list_region";

interface IProps {
    allOffersCount: number;
    className?: string;
    vendorsCount: number;
    region: IVendorRegion[] | null;
    page: number;
}

export const VendorListHeader = (props: IProps) => {
    const offersPluralize = pluralize(["inwestycję", "inwestycje", "inwestycji"]);
    const offersCount = props.region && props.region[0] ? props.region[0].stats.offers_count_for_sale : props.allOffersCount;

    return (
        <header className={props.className}>
            <SeoMainHeadline as="h1" variant="headline_2" highlight className={css({pb: 1})} prefixContent="Deweloper" pageString={` - Strona ${props.page}`}>
                {props.region && props.region[0] ? props.region[0].short_name : "z całej Polski"}
                {props.page > 1 && (
                    <>
                        {" - "}
                        <span className={nonBreakable}>Strona {props.page}</span>
                    </>
                )}
            </SeoMainHeadline>

            {offersCount > 0 && (
                <Text as="p" variant="body_copy_1" className={subheaderStyle}>
                    Deweloperzy{" "}
                    {props.region
                        ? `${props.region[0].name_declension_where} realizują ${numberFormat(
                              props.region[0].stats.offers_count_for_sale
                          )} ${offersPluralize(props.region[0].stats.offers_count_for_sale)}`
                        : `w całej Polsce realizują ${numberFormat(props.allOffersCount)} ${offersPluralize(props.allOffersCount)}`}
                </Text>
            )}
        </header>
    );
};

const subheaderStyle = css({
    color: "var(--colors-gray-600)"
});

const nonBreakable = css({
    whiteSpace: "nowrap"
});
import React from "react";
import {css} from "@panda/css";

import {Text} from "@pg-design/text-module";
import {numberFormat, pluralize} from "@pg-mono/string-utils";

import {SeoMainHeadline} from "../../../atoms/SeoMainHeadline";
import {IVendorRegion} from "../../actions/fetch_vendor_list_region";

interface IProps {
    allOffersCount: number;
    className?: string;
    vendorsCount: number;
    region: IVendorRegion[] | null;
    page: number;
}

export const VendorListHeader = (props: IProps) => {
    const offersPluralize = pluralize(["inwestycję", "inwestycje", "inwestycji"]);
    const offersCount = props.region && props.region[0] ? props.region[0].stats.offers_count_for_sale : props.allOffersCount;

    return (
        <header className={props.className}>
            <SeoMainHeadline as="h1" variant="headline_2" highlight className={css({pb: 1})} prefixContent="Deweloper" pageString={` - Strona ${props.page}`}>
                {props.region && props.region[0] ? props.region[0].short_name : "z całej Polski"}
                {props.page > 1 && (
                    <>
                        {" - "}
                        <span className={nonBreakable}>Strona {props.page}</span>
                    </>
                )}
            </SeoMainHeadline>

            {offersCount > 0 && (
                <Text as="p" variant="body_copy_1" className={subheaderStyle}>
                    Deweloperzy{" "}
                    {props.region
                        ? `${props.region[0].name_declension_where} realizują ${numberFormat(
                              props.region[0].stats.offers_count_for_sale
                          )} ${offersPluralize(props.region[0].stats.offers_count_for_sale)}`
                        : `w całej Polsce realizują ${numberFormat(props.allOffersCount)} ${offersPluralize(props.allOffersCount)}`}
                </Text>
            )}
        </header>
    );
};

const subheaderStyle = css({
    color: "var(--colors-gray-600)"
});

const nonBreakable = css({
    whiteSpace: "nowrap"
});
